module.exports = __webpack_public_path__ + "img/ellipse@3x.5554be8a.png";